import apiClient from '~/config/apiClient';

export const getForgeviewerToken = async (
  onAccessToken: (token: string, expire: number) => void,
) => {
  if (onAccessToken) {
    const { data } = await apiClient.post('/auth/forge');
    onAccessToken(data.access_token, data.expires_in);
  }
};
